import { banco } from '../db/banco'

// Quantos PEDIDOS ABERTOS usam esta tabela de preco.
//
// Conta pedidos, nao sub-pedidos: a mesma tabela pode aparecer em dois blocos
// do mesmo pedido, e a confirmacao de exclusao mentiria o numero.
//
// So pedido ABERTO importa: num pedido fechado os itens ja tem preco proprio e
// o PDF ja foi gerado -- apagar a tabela nao muda nada la.
export async function contarPedidosAbertosComTabela(tabelaId: string): Promise<number> {
  const subs = await banco.sub_pedidos
    .filter((s) => s.apagado_em === null && s.tabela_preco_id === tabelaId)
    .toArray()

  const pedidosAbertos = new Set<string>()
  for (const sub of subs) {
    if (pedidosAbertos.has(sub.pedido_id)) continue
    const pedido = await banco.pedidos.get(sub.pedido_id)
    if (pedido && pedido.apagado_em === null && pedido.status === 'aberto') {
      pedidosAbertos.add(sub.pedido_id)
    }
  }
  return pedidosAbertos.size
}
